import React from 'react';
import ModalSheet from "../../../../components/atoms/modalSheet";
import Button from "../../../../components/atoms/button";
import './EditModal.css';

interface EditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onEdit: (newLandNumber: string) => void;
  currentLandNumber: string;
}

const EditModal: React.FC<EditModalProps> = ({
  isOpen,
  onClose,
  onEdit,
  currentLandNumber
}) => {
  const [parcelNumberOrText, setParcelNumberOrText] = React.useState(currentLandNumber);

  React.useEffect(() => {
    setParcelNumberOrText(currentLandNumber);
  }, [currentLandNumber]);

  const handleEdit = () => {
    onEdit(parcelNumberOrText);
  };

  return (
    <ModalSheet
      isOpen={isOpen}
      initialBreakpoint={0.4}
      breakpoints={[1, 1, 1, 1]}
      onDidDismiss={onClose}
      close={onClose}
    >
      <div className="w-full h-full pt-4 flex flex-col justify-start items-center">
        <p className="font-bold text-primaryColor100 text-2xl">
          ادخل رقم أو اسم القطعة
        </p>

        <div className="w-full mt-4">
          <input
            type="text"
            value={parcelNumberOrText}
            onChange={(e) => setParcelNumberOrText(e.target.value)}
            className="block px-5 py-2.5 font-bold placeholder-paragraphColor w-full text-xl text-primaryColor100 bg-transparent rounded border-2 border-paragraphColor appearance-none  focus:outline-none focus:ring-0 focus:border-blue-600"
            placeholder="الرقم أو الاسم"
          />
        </div>
        <div className="w-full mt-4 px-4 grid grid-cols-2 gap-4">
          <Button
            theme={"primary"}
            text={"موافق"}
            size={"big"}
            onClick={handleEdit}
          />
          <Button
            theme={"danger"}
            text={"إغلاق"}
            size={"big"}
            onClick={onClose}
          />
        </div>
      </div>
    </ModalSheet>
  );
};

export default EditModal;
